import {Inject, Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from "@angular/common";
import {UtilService} from "../util/util.service";

@Pipe({
    name: 'commonDate',
    standalone: false
})
export class CommonDatePipe implements PipeTransform {
  pipe = new DatePipe('en-us');

  constructor(private utilService: UtilService) {
  }

  transform(value: any, ignoreTime?: boolean): any {
    if (!this.utilService.checkIfEmpty(value)) {
      let format = "yyyy-MM-dd HH:mm:ss";
      if (ignoreTime) {
        format = "yyyy-MM-dd"
      }
      return this.pipe.transform(new Date(value), format, "UTC");
    } else {
      return '';
    }
  }

}
